import {
	BlackFridayClaimResultDTO,
	BlackFridayOfferDTO,
	BlackFridaySelectionDTO
} from 'api-models'
import { ApiClient } from '../api-client'

export const BlackFridayOffers = {
	async selection(
		accountId: string,
		onboarding: boolean,
		input?: {
			tier: string
			price_id: string | null
			spend: number
			yearly: boolean
		}
	): Promise<BlackFridaySelectionDTO> {
		const url = onboarding
			? `/onboarding/${accountId}/black-friday-selection`
			: `/accounts/${accountId}/subscriptions/black-friday-selection`
		const { data } = input
			? await ApiClient.client.post(url, input)
			: await ApiClient.client.get(url)
		return data.data
	},
	async onboardingAvailability(): Promise<BlackFridaySelectionDTO> {
		const { data } = await ApiClient.client.get(
			'/users/black-friday-selection'
		)
		return data.data
	},
	async get(
		accountId: string,
		signal?: AbortSignal
	): Promise<BlackFridayOfferDTO> {
		const { data } = await ApiClient.client.get(
			`/accounts/${accountId}/subscriptions/black-friday-offer`,
			{ timeout: 20000, signal }
		)
		return data.data
	},
	async claim(
		accountId: string,
		quoteVersion: string
	): Promise<BlackFridayClaimResultDTO> {
		const { data } = await ApiClient.client.post(
			`/accounts/${accountId}/subscriptions/black-friday-offer/claim`,
			{ quote_version: quoteVersion },
			{ timeout: 30000 }
		)
		return data.data
	}
}

export const blackFridayOfferQuery = async (
	accountId: string,
	signal?: AbortSignal
) => ({
	offer: await BlackFridayOffers.get(accountId, signal),
	receivedAt: performance.now()
})
